(function () {
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  // Menú: cajón bajo el encabezado
  var t = document.querySelector('[data-menu-toggle]'), m = document.querySelector('[data-menu]');
  if (t && m) t.addEventListener('click', function () {
    m.hidden = !m.hidden; t.setAttribute('aria-expanded', String(!m.hidden));
  });

  // Pestañas "Cómo funciona / Qué incluye": abren y cierran su panel
  $$('[data-tabs]').forEach(function (box) {
    var btns = $$('[data-tab]', box);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        btns.forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
          var p = document.getElementById(o.getAttribute('data-tab')); if (p) p.hidden = true;
        });
        if (!open) {
          b.setAttribute('aria-expanded', 'true');
          var p = document.getElementById(b.getAttribute('data-tab')); if (p) p.hidden = false;
        }
      });
    });
  });

  // Variante elegida (kit, selector o fija): actualiza tarjetas, precio del botón, cuotas y barra fija.
  // Los bloques viven fuera del <form> y se conectan con form="", por eso se leen con form.elements.
  function clp(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CL'); }
  $$('[data-buy]').forEach(function (form) {
    var scope = form.closest('[data-section]') || document;
    function selected() {
      var els = Array.prototype.slice.call(form.elements), pick = null;
      els.forEach(function (el) {
        if (el.name !== 'id') return;
        if (el.type === 'radio') { if (el.checked) pick = el; }
        else if (el.tagName === 'SELECT') { pick = el.options[el.selectedIndex]; }
        else if (!pick) { pick = el; }
      });
      return pick;
    }
    function sync() {
      var sel = selected();
      $$('.kit', scope).forEach(function (k) { var r = k.querySelector('input'); k.classList.toggle('is-on', !!(r && r.checked)); });
      if (!sel) return;
      var price = sel.getAttribute('data-price'), cents = parseInt(sel.getAttribute('data-cents'), 10);
      if (price) {
        $$('[data-btn-price]', scope).forEach(function (el) { el.textContent = price; });
        $$('[data-sticky-price]').forEach(function (el) { el.textContent = price; });
      }
      if (!isNaN(cents)) $$('[data-cuota]', scope).forEach(function (el) {
        var n = parseInt(el.getAttribute('data-cuota'), 10); if (n > 1) el.textContent = clp(cents / n);
      });
    }
    scope.addEventListener('change', function (e) { if (e.target.form === form || e.target.getAttribute('form') === form.id) sync(); });
    sync();
  });

  // Galería: miniaturas y deslizamiento
  $$('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('.gal__main'), thumbs = $$('.gal__thumb', g);
    if (!track) return;
    var slides = track.children;
    thumbs.forEach(function (b, n) {
      b.addEventListener('click', function () {
        track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
    function mark() {
      var n = Math.round(track.scrollLeft / (track.clientWidth || 1));
      thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === n); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
  });

  // Antes y después: deslizador y pestañas de casos
  $$('[data-ba]').forEach(function (c) {
    var r = c.querySelector('[data-ba-range]');
    if (r) r.addEventListener('input', function () { c.style.setProperty('--pos', r.value + '%'); });
  });
  $$('.ba').forEach(function (sec) {
    var tabs = $$('[data-ba-tab]', sec), pairs = $$('[data-ba-pair]', sec);
    tabs.forEach(function (tb) {
      tb.addEventListener('click', function () {
        var n = tb.getAttribute('data-ba-tab');
        tabs.forEach(function (o) { o.classList.toggle('is-on', o === tb); });
        pairs.forEach(function (p) { p.hidden = p.getAttribute('data-ba-pair') !== n; });
      });
    });
  });

  // Reseñas: paginación simple
  $$('[data-paged]').forEach(function (list) {
    var per = parseInt(list.getAttribute('data-paged'), 10) || 6;
    var items = $$('.rev__item', list), pages = Math.ceil(items.length / per), cur = 0;
    var pager = list.parentNode.querySelector('[data-pager]');
    if (!pager || pages < 2) return;
    pager.hidden = false;
    var lab = pager.querySelector('[data-page]'), prev = pager.querySelector('[data-prev]'), next = pager.querySelector('[data-next]');
    function show() {
      items.forEach(function (it, i) { it.hidden = Math.floor(i / per) !== cur; });
      lab.textContent = (cur + 1) + ' / ' + pages; prev.disabled = cur === 0; next.disabled = cur === pages - 1;
    }
    prev.addEventListener('click', function () { if (cur > 0) { cur--; show(); } });
    next.addEventListener('click', function () { if (cur < pages - 1) { cur++; show(); } });
    show();
  });

  // Barra fija en móvil cuando el botón principal sale de pantalla
  var sticky = document.querySelector('[data-sticky]');
  var mainBtn = document.querySelector('.pdp .btn--buy[name="add"]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var footer = document.querySelector('.ftr'), past = false, nearFooter = false;
    function upd() { sticky.classList.toggle('is-on', past && !nearFooter && window.innerWidth < 990); }
    new IntersectionObserver(function (e) { past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; upd(); }).observe(mainBtn);
    if (footer) new IntersectionObserver(function (e) { nearFooter = e[0].isIntersecting; upd(); }).observe(footer);
    window.addEventListener('resize', upd);
  }
})();

/* ───────────── Carrito (lateral y página) ───────────── */
(function () {
  var R = (window.theme && window.theme.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update' };
  var lastFocus = null, busy = false;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function drawer() { return $('[data-cart-drawer]'); }
  function onCartPage() { return document.body.classList.contains('template-cart'); }
  function ids() {
    var out = [];
    $$('[data-cart-root]').forEach(function (r) { var id = r.getAttribute('data-section-id'); if (id && out.indexOf(id) < 0) out.push(id); });
    return out;
  }

  function open() {
    var d = drawer(); if (!d) { window.location.href = R.cart; return; }
    if (onCartPage()) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-lock');
    var panel = $('.cd__panel', d); if (panel) setTimeout(function () { panel.focus(); }, 30);
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function render(sections) {
    if (!sections) return;
    $$('[data-cart-root]').forEach(function (root) {
      var html = sections[root.getAttribute('data-section-id')]; if (!html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-root]');
      if (!fresh) return;
      root.innerHTML = fresh.innerHTML;
      var n = fresh.getAttribute('data-count') || '0';
      root.setAttribute('data-count', n);
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === '0'; });
    });
  }
  function refresh() {
    var list = ids(); if (!list.length) return Promise.resolve();
    return fetch(R.root + '?sections=' + list.join(','), { headers: { 'X-Rube': '1' } })
      .then(function (r) { return r.json(); }).then(render);
  }
  function post(url, body, isForm) {
    var opts = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-Rube': '1', 'Accept': 'application/json' } };
    if (isForm) { opts.body = body; } else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function setBusy(on) { busy = on; $$('[data-cart-root]').forEach(function (r) { r.classList.toggle('is-busy', on); }); }
  function showErr(e, root) {
    var msg = (e && (e.description || e.message)) || 'No pudimos actualizar el carrito. Inténtalo de nuevo.';
    var box = root || $('[data-cart-root]'); if (!box) return;
    var p = document.createElement('p'); p.className = 'cd__err'; p.setAttribute('role', 'alert'); p.textContent = msg;
    box.insertBefore(p, box.firstChild);
    setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 5000);
  }
  function change(key, qty, root) {
    if (busy) return; setBusy(true);
    post(R.cartChange + '.js', { id: key, quantity: qty, sections: ids().join(',') })
      .then(function (d) { render(d.sections); })
      .catch(function (e) { showErr(e, root); refresh(); })
      .then(function () { setBusy(false); });
  }
  function addItems(items, root) {
    if (busy) return; setBusy(true);
    post(R.cartAdd + '.js', { items: items, sections: ids().join(',') })
      .then(function (d) { render(d.sections); })
      .catch(function (e) { showErr(e, root); })
      .then(function () { setBusy(false); });
  }

  // Clics: abrir, cerrar, cantidades, eliminar, upsells
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
    if (t.closest('[data-cart-close-link]') && t.closest('[data-cart-drawer]') && document.body.classList.contains('template-product')) { e.preventDefault(); close(); return; }
    var root = t.closest('[data-cart-root]'); if (!root) return;
    var line = t.closest('[data-line-key]');
    if (line && t.closest('[data-remove]')) { change(line.getAttribute('data-line-key'), 0, root); return; }
    var step = t.closest('[data-qty-step]');
    if (line && step) {
      var input = $('[data-qty-input]', line), q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
      input.value = q; change(line.getAttribute('data-line-key'), q, root); return;
    }
    var addBtn = t.closest('[data-add-variant]');
    if (addBtn) { addItems([{ id: parseInt(addBtn.getAttribute('data-add-variant'), 10), quantity: 1 }], root); return; }
    var addSel = t.closest('[data-add-select]');
    if (addSel) { var sel = $('[data-up-select]', addSel.parentNode); if (sel) addItems([{ id: parseInt(sel.value, 10), quantity: 1 }], root); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target, root = t.closest && t.closest('[data-cart-root]'); if (!root) return;
    if (t.matches('[data-qty-input]')) { var line = t.closest('[data-line-key]'); change(line.getAttribute('data-line-key'), Math.max(0, parseInt(t.value, 10) || 0), root); }
    if (t.matches('[data-addon-variant]')) {
      if (t.checked) addItems([{ id: parseInt(t.getAttribute('data-addon-variant'), 10), quantity: 1 }], root);
      else if (t.getAttribute('data-addon-key')) change(t.getAttribute('data-addon-key'), 0, root);
    }
    if (t.matches('[data-cart-note]')) post(R.cartUpdate + '.js', { note: t.value }).catch(function () {});
  });
  document.addEventListener('keydown', function (e) { var d = drawer(); if (e.key === 'Escape' && d && d.classList.contains('is-open')) close(); });

  // Botón de compra: agrega sin salir de la página y abre el carrito
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax="drawer"], form[data-ajax="cart"], form[data-ajax="true"]')) return;
    var mode = form.getAttribute('data-ajax');
    e.preventDefault();
    var btn = form.querySelector('[name="add"]') || document.querySelector('[form="' + form.id + '"][name="add"]');
    var wrap = form.closest('.buybtn') || (btn && btn.parentNode);
    var err = wrap && wrap.querySelector('[data-cart-error]');
    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var fd = new FormData(form);
    fd.append('sections', ids().join(','));
    fd.append('sections_url', window.location.pathname);
    post(R.cartAdd + '.js', fd, true)
      .then(function (d) {
        if (mode === 'cart') { window.location.href = R.cart; return; }
        render(d.sections); open();
      })
      .catch(function (ex) {
        if (err) { err.textContent = (ex && (ex.description || ex.message)) || 'No pudimos agregar el producto. Inténtalo de nuevo.'; err.hidden = false; }
      })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }, true);

  // Si una app envía el formulario "a mano" (form.submit()), igual pasa por el manejo de arriba
  var origSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (this.matches && this.matches('form[data-ajax="cart"], form[data-ajax="drawer"]')) {
      var ev = new Event('submit', { bubbles: true, cancelable: true });
      if (!this.dispatchEvent(ev)) return;
    }
    return origSubmit.call(this);
  };

  // Apps que agregan al carrito por su cuenta (ej: Kaching Bundles): refrescar y abrir
  var isAdd = function (url) { return typeof url === 'string' && /\/cart\/add(\.js|\.json)?(\?|$)/.test(url); };
  var appOn = function () { var d = drawer(); return d && d.getAttribute('data-open-on-app') === 'true'; };
  var onAppAdd = function () {
    if (document.querySelector('form[data-ajax="cart"]')) { window.location.href = R.cart; return; }
    if (appOn()) refresh().then(open); else refresh();
  };
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = init && init.headers, mine = h && (h['X-Rube'] || (h.get && h.get('X-Rube')));
    var p = origFetch.apply(this, arguments);
    if (isAdd(url) && !mine) p.then(function (r) { if (r.ok) setTimeout(onAppAdd, 60); }).catch(function () {});
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isAdd(url)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) setTimeout(onAppAdd, 60); });
    return origOpen.apply(this, arguments);
  };

  // Editor de temas: al seleccionar el carrito lateral, se abre
  function inDrawer(e) { return e.target && e.target.querySelector && (e.target.querySelector('[data-cart-drawer]') || (e.target.closest && e.target.closest('[data-cart-drawer]'))); }
  document.addEventListener('shopify:section:select', function (e) { if (inDrawer(e)) open(); });
  document.addEventListener('shopify:section:load', function (e) { if (inDrawer(e)) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (inDrawer(e)) close(); });
  document.addEventListener('shopify:block:select', function (e) { if (e.target.closest && e.target.closest('[data-cart-drawer]')) open(); });

  window.RubeCart = { open: open, close: close, refresh: refresh };
})();

/* ───────────── Carrusel (reseñas) ───────────── */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-slider]'), function (s) {
    var track = s.querySelector('[data-slider-track]'), dots = s.querySelector('[data-slider-dots]');
    if (!track) return;
    var slides = track.children, n = slides.length, timer = null;
    function idx() {
      var best = 0, min = Infinity;
      for (var i = 0; i < n; i++) { var d = Math.abs(slides[i].offsetLeft - track.offsetLeft - track.scrollLeft); if (d < min) { min = d; best = i; } }
      return best;
    }
    function go(i) { i = (i + n) % n; track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    if (dots && n > 1) {
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Reseña ' + (i + 1));
        (function (k) { b.addEventListener('click', function () { go(k); }); })(i);
        dots.appendChild(b);
      }
    }
    function mark() { var k = idx(); if (dots) Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-on', j === k); }); }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    var prev = s.querySelector('[data-slider-prev]'), next = s.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    var secs = parseInt(s.getAttribute('data-autoplay'), 10) || 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function start() { if (secs > 0 && n > 1 && !reduce) { stop(); timer = setInterval(function () { go(idx() + 1); }, secs * 1000); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    s.addEventListener('mouseenter', stop); s.addEventListener('mouseleave', start);
    s.addEventListener('touchstart', stop, { passive: true });
    mark(); start();
  });
})();

/* ───────────── Cuenta regresiva ───────────── */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-countdown]'), function (el) {
    var raw = (el.getAttribute('data-countdown') || '').trim().replace(' ', 'T');
    var end = new Date(raw).getTime();
    var hint = el.parentNode.querySelector('[data-countdown-hint]');
    if (isNaN(end) || end <= Date.now()) return;
    if (hint) hint.hidden = true;
    el.hidden = false;
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function tick() {
      var t = Math.max(0, end - Date.now());
      if (t === 0) { el.hidden = true; return clearInterval(iv); }
      var s = Math.floor(t / 1000);
      el.querySelector('[data-u="d"]').textContent = pad(Math.floor(s / 86400));
      el.querySelector('[data-u="h"]').textContent = pad(Math.floor(s % 86400 / 3600));
      el.querySelector('[data-u="m"]').textContent = pad(Math.floor(s % 3600 / 60));
      el.querySelector('[data-u="s"]').textContent = pad(s % 60);
    }
    var iv = setInterval(tick, 1000); tick();
  });
})();

/* ───────────── Fecha de entrega (días hábiles) ───────────── */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-eta]'), function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 0, max = parseInt(el.getAttribute('data-max'), 10) || min;
    var tpl = el.getAttribute('data-template') || '';
    function addBiz(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    function fmt(d) { return d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' }).replace(',', ''); }
    var out = tpl.replace('[desde]', '<strong>' + fmt(addBiz(min)) + '</strong>').replace('[hasta]', '<strong>' + fmt(addBiz(max)) + '</strong>');
    var span = el.querySelector('[data-eta-text]'); if (span && tpl) span.innerHTML = out;
  });
})();
